import { IPasswordRecoveryStep } from '../../passwordRecoverySteps';
import PasswordRecoveryCompletedPage from '.';

const PasswordRecoveryCompletedStep: IPasswordRecoveryStep = {
  name: 'Senha criada com sucesso',
  step: (props: any) => <PasswordRecoveryCompletedPage {...props} />,
};

export default PasswordRecoveryCompletedStep;
